<template>
    <div class="card card-with-shadow border-0 h-100 min-height-350">
        <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
            <h5 class="card-title text-capitalize mb-0">{{ $t('poll_question_analytics') }}</h5>
        </div>
        <div class="card-body d-flex flex-column justify-content-center align-items-center position-relative p-primary" :class="{ 'loading-opacity': preloader }">
            <app-overlay-loader v-if="loader"/>
            <template v-else>
                <app-chart
                    type="dough-chart"
                    :height="230"
                    :labels="['Yes', 'No']"
                    :data-sets="pollQuestionAnalyticsDataSets"
                />
                <div class="chart-data-list mt-3">
                    <div class="data-group-item">
                        <span class="square" style="background-color: #4CAF50;"></span>
                        <span class="value">Yes - {{ totalYes }}</span>
                    </div>
                    <div class="data-group-item">
                        <span class="square" style="background-color: #F44336;"></span>
                        <span class="value">No - {{ totalNo }}</span>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import {axiosGet} from '../../../../../common/Helper/AxiosHelper';
import {APP_DASHBOARD} from '../../../../Config/ApiUrl';
import {mapState} from 'vuex';

export default {
    name: 'PollQuestionAnalytics',

    data() {
        return {
            preloader: false,
            totalYes: 0,
            totalNo: 0,
            pollQuestionAnalyticsDataSets: []
        };
    },

    computed: {
        ...mapState({
            loader: state => state.loading
        })
    },

    created() {
        this.getPollAnalyticsData();
    },

    methods: {
        getPollAnalyticsData() {
            this.preloader = true;

            axiosGet(`${APP_DASHBOARD}/poll-questions/analytics`)
                .then(({data}) => {
                    let totalYes = 0;
                    let totalNo = 0;

                    data.forEach(poll => {
                        totalYes += poll.yes_count;
                        totalNo += poll.no_count;
                    });

                    this.totalYes = totalYes;
                    this.totalNo = totalNo;

                    this.pollQuestionAnalyticsDataSets = [
                        {
                            borderWidth: 0,
                            backgroundColor: ['#4CAF50', '#F44336'],
                            data: [totalYes, totalNo]
                        }
                    ];

                    this.preloader = false;
                })
                .catch((err) => {
                    console.error('Poll Analytics Error:', err.message);
                    this.$toastr.e('Failed to load poll analytics data');
                    this.preloader = false;
                });
        }
    }
};
</script>
